export const COOKIES = {
  NV_ACCESS_TOKEN: 'nv_access_token',
  NV_SHIPPER_ID: 'nv_shipper_id'
}
